import React, { useState } from "react";
import { Button, Card, notification, Alert, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import directApproval from "../../services/directApproval";

const { Title } = Typography;

const DirectApproval = () => {
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const [approved, setApproved] = useState(false);
  const navigate = useNavigate();

  const handleApprove = async () => {
    setLoading(true);
    try {
      const searchParams = window.location.search;
      const data = await directApproval.directApproval(searchParams);

      setApproved(true);
      api.success({
        message: "Approved",
        description: data?.message || "Form has been approved successfully.",
      });
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong while approving the form.";

      api.error({
        message: "Error",
        description: msg,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {contextHolder}

      {/* Login button top-right */}
      <Button
        type="primary"
        style={{ position: "absolute", top: 20, right: 20 }}
        onClick={() => navigate("/login")}
      >
        Login
      </Button>

      <Card style={{ width: 400, textAlign: "center" }}>
        {!approved && (
          <Title level={2} style={{ marginBottom: 20 }}>
            Please approve the form
          </Title>
        )}

        {!approved ? (
          <Button
            type="primary"
            onClick={handleApprove}
            loading={loading}
            block
            size="large"
          >
            Approve
          </Button>
        ) : (
          <Alert message="Form approved successfully!" type="success" showIcon />
        )}
      </Card>
    </div>
  );
};

export default DirectApproval;
